import React from 'react';
import { styled } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import FilterSearch from '@atlassian/jira-common-analytics-v2-wrapped-components/src/filter-search';
import { fg } from '@atlassian/jira-feature-gating';
import { useIntl } from '@atlassian/jira-intl';
import { TRASHED_STATUS } from '../../common/constants';
import messages from './messages';
import type { Props } from './types';

const Filters = (props: Props) => {
	const { onFilterChange, filter, status } = props;

	const onFilterSearchChange = (value: string): void => {
		onFilterChange({ text: value });
	};

	const { formatMessage } = useIntl();

	const filterSearchLabel =
		status === TRASHED_STATUS ? messages.trashedPlansAriaLabel : messages.archivedPlansAriaLabel;

	return (
		<FilterContainer>
			{/* @ts-expect-error - Type '{ value: string; onChange: (value: string) => void; isAlwaysExpanded: true; }' is missing the following properties from type 'Omit<{ value: string; placeholder: string; describedById?: string | undefined; hasAutoFocus: boolean; isCompact: boolean; onChange: (value: string, args_1: UIAnalyticsEvent) => void; ... 6 more ...; key?: Key | ... 1 more ... | undefined; }, keyof WithAnalyticsEventsProps>': placeholder, hasAutoFocus, isCompact, increasedWidth, placeholderAlwaysVisible */}
			<FilterSearch
				value={filter.text}
				onChange={onFilterSearchChange}
				isAlwaysExpanded
				{...(fg('jira-a11y-violations-label-trashed-plans-directory') && {
					ariaLabelText: formatMessage(filterSearchLabel),
				})}
			/>
		</FilterContainer>
	);
};

export default Filters;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const FilterContainer = styled.div({
	position: 'relative',
	display: 'flex',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
	'& > :not(:last-child)': {
		marginRight: token('space.200', '16px'),
	},
	marginBottom: token('space.200', '16px'),
});
